import app from '../../admin/app';
import SettingsModal from './SettingsModal';
export default class EditCustomFooterModal extends SettingsModal {
  className() {
    return 'EditCustomFooterModal TextareaCodeModal Modal--large';
  }
  title() {
    return app.translator.trans('core.admin.edit_footer.title');
  }
  form() {
    return [m("p", null, app.translator.trans('core.admin.edit_footer.customize_text')), m("div", {
      className: "Form-group"
    }, m("textarea", {
      className: "FormControl",
      rows: "30",
      bidi: this.setting('custom_footer')
    }))];
  }
  onsaved() {
    window.location.reload();
  }
}
flarum.reg.add('core', 'admin/components/EditCustomFooterModal', EditCustomFooterModal);